<template>
<div v-html="item.value"></div>
</template>

<script>
import itemMixin from '@/components/appUser/questionnaires/pageItems/itemMixin'

export default {
  name: 'RichTextItem',
  mixins: [itemMixin]
}
</script>

<style scoped>

</style>
